(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4453],{

/***/ 25537:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-settings",
      function () {
        return __webpack_require__(56155);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64889);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43634);
/* harmony import */ var _components_Page_AccountSetting__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51051);
/* harmony import */ var _components_Global_MainLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37696);






function Page() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page_AccountSetting__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        langCode: _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_5__/* .ELanguage.EN */ .Df.EN
    });
};
Page.getLayout = function getLayout(page) {
    var userIP = page.props.userIP;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_store__WEBPACK_IMPORTED_MODULE_2__/* .AppStoreProvider */ .kA, {
        langCode: _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_5__/* .ELanguage.EN */ .Df.EN,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Global_MainLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            pageName: _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_5__/* .EPages.ACCOUNT_SETTINGS */ .QS.ACCOUNT_SETTINGS,
            userIp: userIP,
            responsiveCornerColor: "#f7f8fa",
            children: page
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3775,3022,9239,4430,8508,3634,1051,9774,2888,179], function() { return __webpack_exec__(25537); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);